import {
    CREATE_DYEING_DETAILS_FAILURE,
    CREATE_DYEING_DETAILS_REQUEST,
    CREATE_DYEING_DETAILS_SUCCESS,
    CREATE_USERFORM_DYEING_DETAILS,
    DELETE_DYEING_DETAILS_FAILURE,
    DELETE_DYEING_DETAILS_REQUEST,
    DELETE_DYEING_DETAILS_SUCCESS,
    FETCH_ALL_DYEING_DETAILS_FAILURE,
    FETCH_ALL_DYEING_DETAILS_REQUEST,
    FETCH_ALL_DYEING_DETAILS_SUCCESS,
    FETCH_BY_ID_DYEING_DETAILS_FAILURE,
    FETCH_BY_ID_DYEING_DETAILS_REQUEST,
    FETCH_BY_ID_DYEING_DETAILS_SUCCESS,
    RESET_DYEING_DETAILS_USERFORM,
    UPDATE_DYEING_DETAILS_FAILURE,
    UPDATE_DYEING_DETAILS_REQUEST,
    UPDATE_DYEING_DETAILS_SUCCESS
} from "./DyeingDetails.actionType";

export const DYEING_DETAILS = 'dyeingDetails';

let initialState = {
    loading: false,
    dyeingDetailsData: [],
    userform: {},
    errorMessage: '',
}

export let DyeingDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_ALL_DYEING_DETAILS_REQUEST:
        case FETCH_BY_ID_DYEING_DETAILS_REQUEST:
        case CREATE_DYEING_DETAILS_REQUEST:
        case UPDATE_DYEING_DETAILS_REQUEST:
        case DELETE_DYEING_DETAILS_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case FETCH_ALL_DYEING_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                dyeingDetailsData: updatePayload
            }
        case FETCH_BY_ID_DYEING_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            }
        case CREATE_USERFORM_DYEING_DETAILS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            }
        case CREATE_DYEING_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            }
        case UPDATE_DYEING_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            }
        case DELETE_DYEING_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            }
        case FETCH_ALL_DYEING_DETAILS_FAILURE:
        case FETCH_BY_ID_DYEING_DETAILS_FAILURE:
        case CREATE_DYEING_DETAILS_FAILURE:
        case UPDATE_DYEING_DETAILS_FAILURE:
        case DELETE_DYEING_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case RESET_DYEING_DETAILS_USERFORM:
            return {
                ...state,
                loading: false,
                userform: {},
            };

        default:
            return state;
    }
}